export class Calendar {
    constructor() {
    }

    init() {
        $(document).on('click', '.js-import-calendar-button', (e) => this.importCalendar(e));
    }

    importCalendar(e) {
        e.preventDefault();

        let $button = $('.js-import-calendar-button');
        let pagelink = $button.attr("data-value");

        $.ajax({
            type: 'GET',
            url: '/api/account/importcalendar/',
            data: { Pagelink: pagelink },
            success: function () {
                // refresh the page if username and password are correct
                location.reload();
            }
        });
    }

    setLoginErrorMessage(msg, clearFirst) {
        if (clearFirst)
            $('#login-form-errors').html("");

        if (msg)
            $('#login-form-errors').append(msg);
    }
}



// WEBPACK FOOTER //
// ./frontend/js/components/ost.calendar.js